(() => {
  'use strict';
  const script = document.querySelector('[data-jr-cart-integration]');
  const labels = { loading: script?.dataset.loadingText, error: script?.dataset.errorText };
  const ready = () => new Promise(resolve => {
    const deadline = Date.now() + 4000;
    const check = () => {
      const api = window.essentialCartApi;
      if (typeof api?.openCart === 'function') resolve(api);
      else if (Date.now() >= deadline) resolve(null);
      else setTimeout(check, 100);
    };
    check();
  });
  const open = async () => {
    const api = await ready();
    if (!api) {
      window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      return;
    }
    try { await api.refreshCart?.(); } catch {}
    if (!api.isOpen?.()) api.openCart();
  };
  window.JuneReedCart = { open, labels };
})();
